import React from 'react';
import {TextArea} from 'components/tt-forms/common';
import {Link, browserHistory} from 'react-router';
import {ContainerFileDinhKem} from 'components/upload';
import { connect } from 'react-redux';
import { Toastr } from 'modules/toastr';
import { msg } from 'constants/message';
import { GiaiQuyetDonThu, Reception } from 'api';
import moment from 'moment';
import { ShowIf } from 'components/utils';
import {ConfirmDialog} from 'modules/giai-quyet-don/subView';

const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'TIEP_CONG_DAN';

class ThongTinGiaiQuyet extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      id: this.props.id,
      donId: this.props.donId,
      listTaiLieuVanThu: [],
      yKienXuLyKetQuaGiaiQuyet: '',
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      btnLoading: false,
      btnSaveLoading: false,
      showAttach: false,
      donViId: '',
      listTaiLieuVanThuAction: [],
      listTaiLieuVanThuView: [],
      openDialog:false,
      isSave: false
    }
  }

  componentWillMount() {
    this.determinativeVaiTro();
  }

  determinativeVaiTro() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (typeof userInfo == 'undefined') {
      browserHistory.push('/');
    } else {
      this.setState({
        donViId: userInfo.donViId
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      id: nextProps.id,
      donId: nextProps.donId
    }, ()=> {
      this.getDetailReception(nextProps.id);
    });
  }

  componentDidMount() {
    this.getDetailReception(this.props.id);
  }
  getDonInfo(inputId) {
    Reception.actions.getDonInfo.request({ id: inputId }).then(res => {
      if (res.data) {
        this.setState({
          listTaiLieuVanThu: res.data.listTaiLieuVanThu
        }, ()=> {
          this.renderAttachFile();
        });
      }
    });
  }
  getDetailReception(id) {
    Reception.actions.getDetailReception.request({id: id}).then(res => {
      if (res.data) {
        this.getDonInfo(res.data.donSTCD.donId);
        this.setState({
          data: res.data,
          yKienXuLyKetQuaGiaiQuyet: res.data.yKienXuLyKetQuaGiaiQuyet
        })
      } else {
        this.setState({
          data: [],
          yKienXuLyKetQuaGiaiQuyet: ''
        })
      }
    });
  }

  handleChange(e) {
    this.setState({
      yKienXuLyKetQuaGiaiQuyet: e.target.value
    })
  }

  handleSave() {
    this.setState({isSave: true}, () => {

      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true,
          btnSaveLoading: true
        });
        this.state.dataFileDinhKem.map((item, i) => {
          if (item.taiLieuVanThuId) {
            this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(this.state.donId)
              },
              soTiepCongDan: {
                id: Number(this.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
              don: {
                id: Number(this.state.donId)
              },
              soTiepCongDan: {
                id: Number(this.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: loaiQuyTrinh,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        if(this.state.taiLieuVanThu.length > 0) {
          let params = {
            taiLieuVanThus: this.state.taiLieuVanThu
          }
          this.postTaiLieuVanThu(params);
        }

        if(this.state.taiLieuVanThuUpdate.length > 0) {
          let params = {
            taiLieuVanThus: this.state.taiLieuVanThuUpdate
          }
          this.updateTaiLieuVanThu(params);
        }

        if(this.state.taiLieuVanThuDelete.length > 0) {

          let params = {
            taiLieuVanThus: this.state.taiLieuVanThuDelete
          }
          this.deleteTaiLieuVanThu(params);
        }

        let params = this.getParams();

        params.yKienXuLyKetQuaGiaiQuyet = this.state.yKienXuLyKetQuaGiaiQuyet;
        this.updateTiepCongDan(params, 'gqdLuu');
      }
    });
  }

  getParams() {
    let Data = this.state.data;

    let donViPhoiHops = []
    if (Data.danhSachDonViPhoiHops.length > 0) {
      Data.danhSachDonViPhoiHops.map(state => {
        let item = {
          id: state.coQuanQuanLyId
        }
        donViPhoiHops[donViPhoiHops.length] = item
      });
    }
    let coQuanToChucTiepDans = []
    if (Data.coQuanToChucTiepDanSTCD.length > 0) {
      Data.coQuanToChucTiepDanSTCD.map(state => {
        let item = {
          chucVu: state.chucVu,
          nguoiDaiDien: state.nguoiDaiDien,
          coQuanDonVi: {
            id: state.coQuanDonViInfo.coQuanQuanLyId
          }
        }
        coQuanToChucTiepDans[coQuanToChucTiepDans.length] = item
      });
    }
    let Params= {
      canBoTiepDan: {
        id: Data.canBoTiepDanInfo.congChucId
      },
      donViTiepDan: {
        id: this.state.donViId
      },
      don: {
        id: this.state.donId
      },
      loaiTiepDan: Data.loaiTiepDan,
      ngayTiepDan: Data.ngayTiepDan,
      noiDungTiepCongDan: Data.noiDungTiepCongDan,
      diaDiemGapLanhDao: Data.diaDiemGapLanhDao,
      ketQuaGiaiQuyet: Data.ketQuaGiaiQuyet,
      huongXuLy: Data.huongXuLy,
      huongGiaiQuyetTCDLanhDao: Data.huongGiaiQuyetTCDLanhDao,
      donViChuTri: {
        id: Data.donViChuTriInfo.coQuanQuanLyId
      },
      soThuTuLuotTiep: Data.soThuTuLuotTiep,
      donViPhoiHops: donViPhoiHops,
      coQuanToChucTiepDans: coQuanToChucTiepDans,
      ngayBaoCaoKetQua: Data.ngayBaoCaoKetQua,
      ngayGuiKetQua: Data.ngayGuiKetQua,
      noiDungBaoCaoKetQuaKiemTra: Data.noiDungBaoCaoKetQuaKiemTra,
      yKienXuLy: Data.yKienXuLy,
    }

    return Params
  }

  async handleComplete() {
    if (this.validateSubmitForm()) {
      this.setState({
        btnLoading: true,
        openDialog: false
      });
      this.state.dataFileDinhKem.map((item, i) => {
        if (item.taiLieuVanThuId) {
          this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
            don: {
              id: Number(this.state.donId)
            },
            soTiepCongDan: {
              id: Number(this.state.id)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: item.loaiTepDinhKem,
            loaiQuyTrinh: item.loaiQuyTrinh,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        } else {
          this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
            don: {
              id: Number(this.state.donId)
            },
            soTiepCongDan: {
              id: Number(this.state.id)
            },
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: loaiTepDinhKem,
            loaiQuyTrinh: loaiQuyTrinh,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        }
      });

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      if(this.state.taiLieuVanThu.length > 0) {
        let params = {
          taiLieuVanThus: this.state.taiLieuVanThu
        }
        this.postTaiLieuVanThu(params);
      }

      if(this.state.taiLieuVanThuUpdate.length > 0) {
        let params = {
          taiLieuVanThus: this.state.taiLieuVanThuUpdate
        }
        this.updateTaiLieuVanThu(params);
      }

      if(this.state.taiLieuVanThuDelete.length > 0) {

        let params = {
          taiLieuVanThus: this.state.taiLieuVanThuDelete
        }
        this.deleteTaiLieuVanThu(params);
      }

      let params = this.getParams();

      params.yKienXuLyKetQuaGiaiQuyet = this.state.yKienXuLyKetQuaGiaiQuyet;
      params.hoanThanhTCDLanhDao = true
      await this.updateTiepCongDan(params, 'gqdLuuHoSo');
    }
  }

  updateTiepCongDan(params, message) {
    Reception.actions.updateSoTiepCongDan.request({id: this.state.id},params).then(res => {
      this.onClickClose();
      this.props.dispatch({
        type: 'REFRESH_MENU',
        value: true
      });
      Toastr(message? msg[message] : msg.luuGiaiQuyetDonThanhCong, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  onClickClose() {
    browserHistory.goBack();
  }

  onFileChange(data) {
    this.setState ({
      dataFileDinhKem: data
    });
  }

  updateTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  deleteTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  onFileRemove(id, data) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });
    this.setState ({
      dataFileDinhKem: data
    });


  }

  validateSubmitForm() {
    let pass = true;
    if (this.state.dataFileDinhKem.length > 0) {
      this.props.validators['formTaoDon'].map(validator => {
        if(pass) {
          pass = validator.validate();
        } else {
          validator.validate();
        }
      });
    }
    return pass;
  }

  componentWillUnmount() {

  }

  compareDate(firstDate, secondDate, type) {
    var firstTime = firstDate.getTime();
    var secondTime = secondDate.getTime()

    if (firstTime >= secondTime && type == 'show') {
      return true
    } else {
      return false
    }
  }

  renderAttachFile() {
    let DataTaiLieuVanThu = [...this.state.listTaiLieuVanThu];
    let DataTaiLieuVanThuView = [...this.state.listTaiLieuVanThu];

    let listTaiLieuVanThu = DataTaiLieuVanThu.filter(state => {
      return this.compareDate(new Date(state.ngayTao), new Date(this.state.data.thongTinYeuCauKiemTraDeXuatInfo.ngayGuiKQ), 'action');
    })

    let listTaiLieuVanThuView = DataTaiLieuVanThuView.filter(state => {
      return this.compareDate(new Date(this.state.data.thongTinYeuCauKiemTraDeXuatInfo.ngayGuiKQ), new Date(state.ngayTao), 'show');
    })
    this.setState({
      listTaiLieuVanThuAction: listTaiLieuVanThu,
      listTaiLieuVanThuView: listTaiLieuVanThuView,
      showAttach: true
    })
  }

  closeDialog() {
    this.setState({
      openDialog: false
    })
  }

  openDialog() {
    this.setState({isSave: false}, () => {
      if(this.validateSubmitForm()) {
        this.setState({
          openDialog: true
        })
      }
    });
  }

  render() {
    return (
      <section className="wrap-block">
        <div className="wrap-big-line pt5 pb20">
          <span className="big-border"></span>
        </div>
        <h2 className='title-14 mb15'>Thông tin giải quyết</h2>
        <div className='row pl10 pr10'>
          <TextArea className='col-100' value={this.state.yKienXuLyKetQuaGiaiQuyet} label='Ý kiến xử lý' onChange={this.handleChange.bind(this)}/>
          <ShowIf condition={this.state.showAttach}>
            <div className="col-100 pb5">
              <ContainerFileDinhKem label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.listTaiLieuVanThuAction} dataShow={this.state.listTaiLieuVanThuView} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} onSave={this.state.isSave}/>
            </div>
          </ShowIf>
          <div className="box-bottom gqd-wrap col-100">
            <div className="wrap-big-line mt10 mb20"><div className="line-border"></div></div>
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
            <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu tạm</span></Link>
            <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this)}><span>Lưu hồ sơ</span></Link>
          </div>
        </div>
        <ConfirmDialog open={this.state.openDialog} onClose={this.closeDialog.bind(this)} onSuccess={this.handleComplete.bind(this)} title="Xác nhận lưu hồ sơ" content="Bạn có muốn lưu hồ sơ này?"/>
      </section>
    );
  }
}

ThongTinGiaiQuyet.defaultProps = {
  dataTaiLieuVanThu: '',
  yKienXuLyKetQuaGiaiQuyet: '',
  validators: {}
}

export default connect()(ThongTinGiaiQuyet);


// WEBPACK FOOTER //
// ./src/components/modules/reception/ThongTinGiaiQuyet.jsx